import { formatRequest } from "../../utils/function";
import axiosInstance from "../axiosInstance";

export function createCalculateRewardValue(data) {
  return axiosInstance.post(`/calculate-reward-value`, formatRequest(data));
}

export function getRecommendedTransferPartners(data) {
  return axiosInstance.post(`/recommended-transfer-partners`, formatRequest(data));
}

export function getValuationAnalytics(data) {
  return axiosInstance.post(`/valuation-analytics`, formatRequest(data));
}


export function getRewardTransferSummary(data) {
  return axiosInstance.post(`/reward-transfer-summary`, formatRequest(data));
}





